var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('b-jumbotron',{attrs:{"fluid":""}},[_c('h1',{staticClass:"display-1"},[_vm._v("404 Not Found")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }